<template>
  <v-container fluid class="pa-0">
    <v-tabs
      v-model="activeTab"
      class="mb-4"
      color="primary"
      slider-color="primary"
      grow
      @update:model-value="onTabChange"
    >
      <v-tab value="languages">
        <v-icon start>mdi-web</v-icon>
        Языки
      </v-tab>
      <v-tab value="platforms">
        <v-icon start>mdi-layers</v-icon>
        Платформы
      </v-tab>
      <v-tab value="media-kinds">
        <v-icon start>mdi-newspaper</v-icon>
        Типы СМИ
      </v-tab>
      <v-tab value="topics">
        <v-icon start>mdi-sitemap</v-icon>
        Темы
      </v-tab>
      <v-tab value="geolocations">
        <v-icon start>mdi-map-marker</v-icon>
        География
      </v-tab>
      <v-tab value="platform-sections">
        <v-icon start>mdi-tag-multiple-outline</v-icon>
        Рубрики платформ
      </v-tab>
    </v-tabs>

    <v-window v-model="activeTab">
      <!-- Languages Tab -->
      <v-window-item value="languages">
        <LanguagesTable />
      </v-window-item>

      <!-- Platforms Tab -->
      <v-window-item value="platforms">
        <PlatformsTable />
      </v-window-item>

      <!-- Media Kinds Tab -->
      <v-window-item value="media-kinds">
        <MediaKindsTable />
      </v-window-item>

      <!-- Topics Tab -->
      <v-window-item value="topics">
        <TopicsTable />
      </v-window-item>

      <!-- Geolocations Tab -->
      <v-window-item value="geolocations">
        <GeolocationsTable />
      </v-window-item>

      <!-- Platform Sections Tab -->
      <v-window-item value="platform-sections">
        <PlatformSectionsTable />
      </v-window-item>

    </v-window>
  </v-container>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import LanguagesTable from '@/components/references/LanguagesTable.vue'
import PlatformsTable from '@/components/references/PlatformsTable.vue'
import MediaKindsTable from '@/components/references/MediaKindsTable.vue'
import TopicsTable from '@/components/references/TopicsTable.vue'
import GeolocationsTable from '@/components/references/GeolocationsTable.vue'
import PlatformSectionsTable from '@/components/references/PlatformSectionsTable.vue'

export default {
  name: 'ReferenceManagement',
  components: {
    LanguagesTable,
    PlatformsTable,
    MediaKindsTable,
    TopicsTable,
    GeolocationsTable,
    PlatformSectionsTable
  },
  setup() {
    const route = useRoute()
    const activeTab = ref('languages')

    // Set active tab based on route or saved state
    onMounted(() => {
      const routePath = route.path
      const savedTab = localStorage.getItem('references-active-tab')
      
      if (routePath.includes('platforms')) {
        activeTab.value = 'platforms'
      } else if (routePath.includes('media-kinds')) {
        activeTab.value = 'media-kinds'
      } else if (routePath.includes('topics')) {
        activeTab.value = 'topics'
      } else if (routePath.includes('geolocations')) {
        activeTab.value = 'geolocations'
      } else if (routePath.includes('platform-sections')) {
        activeTab.value = 'platform-sections'
      } else if (savedTab && !routePath.includes('/admin/references/')) {
        // If not accessing specific route, restore saved tab
        activeTab.value = savedTab
      } else {
        activeTab.value = 'languages'
      }
    })
    
    // Watch for tab changes and save to localStorage
    const onTabChange = (tab) => {
      activeTab.value = tab
      localStorage.setItem('references-active-tab', tab)
    }

    return {
      activeTab,
      onTabChange
    }
  }
}
</script>

<style scoped>
.v-tab {
  text-transform: none !important;
  font-weight: 500;
}
</style>